<ng-container>
    <div class="dropdowns-wrapper" [formGroup]="regionComparisonChartOptions">
        <mpro-static-dropdown class="data-lens" [title]="'Data lens'" [inputValue]="dropdownLabel" [options]="dataLensOptions"
            (selectionChanged)="dataLensChanged($event)">
        </mpro-static-dropdown>
        <mpro-region-comparison-projections class="projection" formControlName="projections">
        </mpro-region-comparison-projections>
    </div>
    <div class="bar-chart-wrapper">
        <div class="placeholder-wrapper" *ngIf="!showChart()">
            <fa-icon [icon]="faChart"></fa-icon>
            <p class="placeholder-title">No data to display.</p>
            <p class="placeholder-desc">Please select Country and Projection to compare.</p>
        </div>

        <mpro-horizontal-grouped-bar-chart *ngIf="showChart()" [options]="groupedChartOptions" [data]="chartData">
        </mpro-horizontal-grouped-bar-chart>
    </div>
</ng-container>